import React from 'react';
import { PageWrapper, SectionWrapper } from '../components/MotionWrappers';
export function PrivacyPolicy() {
  return <PageWrapper data-id="element-654">
      <div className="bg-white min-h-screen" data-id="element-655">
        <div className="bg-federal-blue py-16 text-white" data-id="element-656">
          <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-657">
            <h1 className="text-4xl font-black mb-4" data-id="element-658">Privacy Policy</h1>
            <p className="text-white/70" data-id="element-659">Last Updated: July 2026</p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-4 md:px-8 py-16 prose prose-slate prose-lg" data-id="element-660">
          <SectionWrapper data-id="element-661">
            <section className="mb-12" data-id="element-662">
              <h2 className="text-2xl font-bold text-federal-blue mb-4" data-id="element-663">
                1. Introduction
              </h2>
              <p className="text-tech-slate leading-relaxed" data-id="element-664">
                Codes & Cogs LLC ("we," "us," or "our") is committed to
                protecting the privacy of our users and clients, particularly
                within the federal and state agency sectors. This Privacy Policy
                outlines how we collect, use, and safeguard information obtained
                through our digital platforms and services.
              </p>
            </section>
          </SectionWrapper>

          <SectionWrapper delay={0.05} data-id="element-665">
            <section className="mb-12" data-id="element-666">
              <h2 className="text-2xl font-bold text-federal-blue mb-4" data-id="element-667">
                2. Information Collection
              </h2>
              <p className="text-tech-slate leading-relaxed" data-id="element-668">
                We collect information necessary to provide mission-critical
                infrastructure and accessibility services. This may include:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-tech-slate" data-id="element-669">
                <li data-id="element-670">Contact information (name, agency email, phone number)</li>
                <li data-id="element-671">Agency or organizational affiliation</li>
                <li data-id="element-672">Technical data related to digital accessibility audits</li>
                <li data-id="element-673">Communication preferences</li>
              </ul>
            </section>
          </SectionWrapper>

          <SectionWrapper delay={0.1} data-id="element-674">
            <section className="mb-12" data-id="element-675">
              <h2 className="text-2xl font-bold text-federal-blue mb-4" data-id="element-676">
                3. Data Usage & Federal Compliance
              </h2>
              <p className="text-tech-slate leading-relaxed" data-id="element-677">
                All data handled by Codes & Cogs is processed in accordance with
                NIST 800-171 and NIST 800-53 standards. Information is used
                strictly for:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-tech-slate" data-id="element-678">
                <li data-id="element-679">
                  Providing and improving our Comply+ platform and Drupal
                  development services
                </li>
                <li data-id="element-680">Responding to federal and state procurement inquiries</li>
                <li data-id="element-681">
                  Ensuring compliance with Section 508 and WCAG 2.1 standards
                </li>
                <li data-id="element-682">
                  Maintaining secure communication channels with agency partners
                </li>
              </ul>
            </section>
          </SectionWrapper>

          <SectionWrapper delay={0.1} data-id="element-683">
            <section className="mb-12" data-id="element-684">
              <h2 className="text-2xl font-bold text-federal-blue mb-4" data-id="element-685">
                4. Data Security
              </h2>
              <p className="text-tech-slate leading-relaxed" data-id="element-686">
                We implement industry-leading security measures, including
                end-to-end encryption and zero-trust architecture, to protect
                sensitive agency data. Access to information is restricted to
                authorized personnel with a clear need-to-know basis.
              </p>
            </section>
          </SectionWrapper>

          <SectionWrapper delay={0.1} data-id="element-687">
            <section className="mb-12" data-id="element-688">
              <h2 className="text-2xl font-bold text-federal-blue mb-4" data-id="element-689">
                5. Contact Information
              </h2>
              <p className="text-tech-slate leading-relaxed" data-id="element-690">
                For questions regarding this Privacy Policy or our data handling
                practices, please contact our Security & Compliance team at:
                <br data-id="element-691" />
                <span className="font-bold" data-id="element-692">Email:</span>{' '}
                security@codesandcogs.com
              </p>
            </section>
          </SectionWrapper>
        </div>
      </div>
    </PageWrapper>;
}